import { CoinIcon } from "../SymbolSelect";
import { formatTradeSymbol, splitTradeSymbol } from "../../tradeUtils";

export default function HistoryGridCard({
  side,
  type,
  symbol,
  totalCost,
  pnl,
  entryPrice,
  openDate,
  exitPrice,
  closeDate,
}) {
  const colorMap = {
    green: { light: "#DCF2E4", dark: "#15A946" },
    red: { light: "#F9DEDE", dark: "#D71F1F" },
  };
  const selectedColor = side === "لانگ" ? colorMap.green : colorMap.red;
  const pnlColor = String(pnl).trim().startsWith("-")
    ? colorMap.red.dark
    : colorMap.green.dark;
  const formattedSymbol = formatTradeSymbol(symbol) || symbol;
  const { base: baseSymbol } = splitTradeSymbol(symbol);

  return (
    <article className="w-full rounded-2xl p-2.5 flex flex-col gap-3 bg-gradient-to-br from-white/10 to-white/5 border border-white/10">
      <div className="w-full flex items-start justify-between gap-2.5">
        <div className="flex items-center gap-1">
          <span
            className="flex items-center justify-center py-1 px-1.5 rounded-md text-xs font-light whitespace-nowrap"
            style={{
              backgroundColor: selectedColor.light,
              color: selectedColor.dark,
            }}
          >
            {side} - {type}
          </span>
        </div>
        <div
          dir="ltr"
          className="flex items-center justify-center gap-1 py-1 px-1.5 rounded-md text-xs font-light whitespace-nowrap text-zi-text-light dark:text-zi-text-dark"
        >
          <span>{formattedSymbol}</span>
          <CoinIcon code={baseSymbol} className="size-4" />
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-1 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            حجم
          </span>
          <span
            dir="ltr"
            className="flex items-center gap-1 text-sm text-zi-text-light dark:text-zi-text-dark"
          >
            <span>{totalCost}</span>
            <CoinIcon code="usdt" className="size-3" />
          </span>
        </div>
        <div className="flex flex-col gap-1 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            سود
          </span>
          <span
            className="flex items-center justify-center py-0.5 px-1 rounded-md text-sm font-light whitespace-nowrap text-zi-text-dark [direction:ltr]"
            style={{ backgroundColor: pnlColor }}
          >
            {pnl}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            ورود
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {entryPrice}
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {openDate}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            خروج
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {exitPrice}
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {closeDate}
          </span>
        </div>
      </div>
    </article>
  );
}
